import React, { useEffect, useRef, useState } from "react";
import { ArrowRight } from "lucide-react";
import { Link } from "@/components/common/Link";
import { Button } from "@/components/ui/button";
export default function HeroBanner() {
  const [scrollProgress, setScrollProgress] = useState(0);
  const sectionRef = useRef<HTMLElement>(null);
  useEffect(() => {
    const handleScroll = () => {
      if (!sectionRef.current) return;
      const scrolled = window.scrollY;
      const sectionHeight = sectionRef.current.offsetHeight;
      const progress = Math.min(scrolled / sectionHeight, 1);
      setScrollProgress(scrolled);
    };
    window.addEventListener("scroll", handleScroll, {
      passive: true
    });
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);
  const parallaxY = scrollProgress * 0.2;
  const scale = 1 + scrollProgress * 0.0005;
  return <section data-section-id="8424" id="wood-deck-builders-hero" ref={sectionRef} className="relative h-screen min-h-[600px] w-full overflow-hidden bg-background text-foreground">
      {}
      <div className="absolute inset-0 z-0" style={{
      transform: `translate3d(0, ${parallaxY}px, 0) scale(${Math.min(scale, 1.1)})`,
      transition: "transform 0.1s ease-out"
    }}>
        <div className="absolute inset-0 bg-secondary/30 z-10" /> {}
        <img src="/img/redwood_deck_railing.jpg" alt="Masterfully crafted Redwood deck with custom railings at sunset" className="h-full w-full object-cover object-center saturate-110 contrast-100" />
      </div>

      {}
      <div className="absolute inset-0 z-10 bg-gradient-to-b from-secondary/40 via-secondary/50 to-secondary/60 mix-blend-multiply" />
      
      {}
      <div className="relative z-20 flex h-full w-full flex-col items-center justify-center px-4 text-center sm:px-6 lg:px-8">
        <div className="max-w-4xl space-y-8">
          {}
          <h1 className="font-default text-5xl font-bold tracking-tight text-primary-foreground sm:text-6xl md:text-7xl lg:text-[72px] lg:leading-[1.1]">
            Master Wood Deck Builders
          </h1>

          {}
          <p className="mx-auto max-w-2xl font-default text-lg font-medium leading-[1.6] text-primary-foreground/90 sm:text-xl">
            Authentic Craftsmanship since 1990. Serving San Francisco, Santa Clara, and Monterey Counties with premium deck installation and custom outdoor living spaces.
          </p>

          {}
          <div className="pt-4">
            <Button asChild size="lg" className="h-14 rounded-sm bg-primary px-10 text-base font-default font-semibold text-primary-foreground shadow-lg transition-transform hover:scale-105 hover:bg-primary/90">
              <Link to="#">
                Get a Free Estimate
                <ArrowRight className="ml-2 size-5" />
              </Link>
            </Button>
          </div>
        </div>
      </div>
    </section>;
}